import { render, staticRenderFns } from "./login-account.vue?vue&type=template&id=192356c2&scoped=true&"
import script from "./login-account.vue?vue&type=script&lang=js&"
export * from "./login-account.vue?vue&type=script&lang=js&"
import style0 from "./login-account.vue?vue&type=style&index=0&id=192356c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192356c2",
  null
  
)

export default component.exports